import sortBy from 'lodash/sortBy'

const createCategoryMap = (categories) =>
  categories.reduce(
    (acc, { id, name, description, displayPriority }) => ({
      ...acc,
      [id]: {
        name,
        description,
        displayPriority,
        templates: [],
        allPreview: true
      }
    }),
    {}
  )

const addTemplateToMap = (categoryMap, { preview = false, ...template }) =>
  template.categories.reduce((acc, categoryId) => {
    const category = acc[categoryId]
    if (category) {
      category.templates.push({ ...template, preview })
      if (!preview) {
        category.allPreview = false
      }
    }
    return acc
  }, categoryMap)

const categoryOrdering = ['allPreview', 'displayPriority', 'name']
const orderTemplateCategories = (categoryTemplates) =>
  sortBy(categoryTemplates, categoryOrdering)

const templateOrdering = ['preview', 'name']
const orderTemplates = (templates) => sortBy(templates, templateOrdering)

export const buildTemplatesByCategory = ({ categories, templates }) => {
  const templateCategories = Object.values(
    templates.reduce(addTemplateToMap, createCategoryMap(categories))
  )
    .filter(({ templates }) => templates.length > 0)
    .map(({ templates, ...category }) => {
      return { ...category, templates: orderTemplates(templates) }
    })
  return orderTemplateCategories(templateCategories)
}
